var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(_vm._s(_vm.$t("UserManagement.Users.Title")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", { staticClass: "table tablerow users-table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "w-20" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("UserManagement.Name")))])
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "w-30" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("UserManagement.Email")))])
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "w-10" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("UserManagement.Users.AccessRight.Title")))
              ])
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "w-30" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("UserManagement.Procurator.Title")))
              ])
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "w-10 centered" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("UserManagement.Users.Operation.Title")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.approvedUsers, function(user, index) {
            return _c("tr", [
              _c("td", [_c("span", [_vm._v(_vm._s(user.fullName))])]),
              _vm._v(" "),
              _c("td", [_c("span", [_vm._v(_vm._s(user.email))])]),
              _vm._v(" "),
              _c("td", [
                user.isAdmin
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("UserManagement.Users.AccessRight.Admin")
                        ) + _vm._s(user.idAdmin)
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("UserManagement.Users.AccessRight.BasicUser")
                        ) + _vm._s(user.idAdmin)
                      )
                    ])
              ]),
              _vm._v(" "),
              user.isAdmin
                ? _c(
                    "td",
                    [
                      _c("check-box-control", {
                        attrs: {
                          title: "UserManagement.Procurator.Yes",
                          id: "user_procurator" + index,
                          disabled: _vm.changingProcuration
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.changeProcuration(user.id, $event)
                          }
                        },
                        model: {
                          value: user.hasProcuration,
                          callback: function($$v) {
                            _vm.$set(user, "hasProcuration", $$v)
                          },
                          expression: "user.hasProcuration"
                        }
                      })
                    ],
                    1
                  )
                : _c("td", { staticClass: "centered" }, [
                    _c("span", [_vm._v("-")])
                  ]),
              _vm._v(" "),
              _c("td", [
                _vm.canBeDeleted(user.isAdmin)
                  ? _c("span", { staticClass: "centered" }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top.center",
                              value: {
                                content: _vm.$t(
                                  "UserManagement.Users.Operation.Delete"
                                )
                              },
                              expression:
                                "{ content: $t('UserManagement.Users.Operation.Delete') }",
                              modifiers: { top: true, center: true }
                            }
                          ],
                          staticClass: "btn btn-link btn-contrast",
                          attrs: {
                            type: "button",
                            "aria-label":
                              _vm.$t("UserManagement.Users.Operation.Delete") +
                              (index + 2) +
                              " -. " +
                              _vm.$t("UserManagement.Users.Operation.Confirm")
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteUser(user.id)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-trash-alt fa-lg centered"
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }